import  { configureStore } from '@reduxjs/toolkit';
import userReducer from '../slices/userSlice';
import transactionSlice from '../slices/transactionSlice';
import  paymentSlice  from '../slices/paymentSlice';
import styleSlice from '../slices/styleSlice';


const user = userReducer;
const transaction = transactionSlice;
const payment = paymentSlice;
const style = styleSlice;

export const store = configureStore({
    reducer: {
        user,
        transaction,
        payment,
        style
    }
  })

  console.log(store);
